import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { LOB_LABELS } from './CustomerAnalyticsUtils';
import { CustomerAnalyticsStyles } from './CustomerAnalyticsStyles';

interface ILOBDropdownProps {
  selectedLOB: string;
  onLOBChange: (lob: string) => void;
}

const LOBDropdown: React.FC<ILOBDropdownProps> = ({ selectedLOB, onLOBChange }) => {
  const handleChange = (event: SelectChangeEvent) => {
    onLOBChange(event.target.value);
  };

  return (
    <FormControl size="small" sx={{...CustomerAnalyticsStyles.statusDropdown, marginLeft:'1rem'}}>
      <InputLabel id="lob-select-label">Line of Business</InputLabel>
      <Select
        labelId="lob-select-label"
        id="lob-select"
        value={selectedLOB}
        label="Line of Business"
        onChange={handleChange}
      >
        <MenuItem value="All">All</MenuItem>
        {Object.entries(LOB_LABELS).map(([key, value]) => (
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LOBDropdown; 